import CloseIcon from "@rsuite/icons/Close";
import React, { useEffect, useState } from "react";

import Texts from "../../../texts/texts";
import Buttons from "../../../buttons/buttons";
import DetectPlatformService from "../../../../services/detectPlatform";

import "./BottomSheet.scss";

const BottomSheet = (props) => {
  const { bottomSheetConfig } = props;
  const { haveShowMore } = props;
  const { title } = bottomSheetConfig;
  const { dismissible } = bottomSheetConfig;
  let { styles } = bottomSheetConfig;
  const { buttons } = bottomSheetConfig;
  const { texts } = bottomSheetConfig;
  const { opened } = bottomSheetConfig;
  const [showMore, setShowMore] = useState(false);
  const [platform, setPlatform] = useState("unknown");

  useEffect(() => {
    const platform = DetectPlatformService;
    setPlatform(platform);
  }, []);

  useEffect(() => {
    if (!opened) {
      setShowMore(opened);
    }
  }, [opened]);

  const sliceButtons = buttons?.slice(
    0,
    haveShowMore ? (showMore ? buttons?.length : 1) : buttons?.length
  );

  return (
    <>
      <div
        className={`bottom-sheet-overlay ${opened ? "opened" : ""}`}
        onClick={(e) => (opened ? dismiss() : false)}
      ></div>
      <div
        className={`bottom-sheet os-${platform}-bottom-sheet ${
          opened ? "opened" : ""
        }`}
        style={styles ? styles : {}}
      >
        {title ? <div className="bs-title">{title}</div> : ""}
        {dismissible ? (
          <div className="bs-dismiss" onClick={dismiss}>
            <CloseIcon />
          </div>
        ) : (
          ""
        )}
        {title ? (
          <div className="bs-line-container">
            <div className="bs-line"></div>
          </div>
        ) : (
          ""
        )}

        <div className="bs-body">
          {texts ? (
            <div className="bs-texts">
              <Texts texts={texts} />
            </div>
          ) : (
            ""
          )}
          <div className={`bs-buttons ${!showMore && haveShowMore && "pb-4"}`}>
            {buttons ? <Buttons buttons={sliceButtons} /> : ""}
            {!showMore && haveShowMore && (
              <button
                onClick={() => setShowMore(true)}
                className="bottom-sheet-show-more-button "
              >
                مشاهده همه{" "}
                <svg
                  width="7"
                  height="12"
                  viewBox="0 0 7 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.97803 11.8906C5.84536 11.8906 5.71269 11.8462 5.60794 11.751L1.05513 7.61435C0.314954 6.94182 0.314954 5.83785 1.05513 5.16532L5.60794 1.02862C5.81045 0.844626 6.14562 0.844626 6.34812 1.02862C6.55063 1.21261 6.55063 1.51716 6.34812 1.70115L1.79532 5.83785C1.46014 6.14239 1.46014 6.63727 1.79532 6.94181L6.34812 11.0785C6.55063 11.2625 6.55063 11.567 6.34812 11.751C6.24338 11.8399 6.11071 11.8906 5.97803 11.8906Z"
                    fill="#0EAD98"
                  />
                </svg>
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );

  function dismiss() {
    let config = { ...bottomSheetConfig };
    config.opened = false;
    props.bottomSheetHandler(config);

    return true;
  }
};

export default BottomSheet;
